var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      ref: _vm.dialogRef,
      attrs: { id: "general-form-wrapper", "md-click-outside-to-close": true }
    },
    [
      _c("md-dialog-title", [
        _c("h3", { staticClass: "md-headline" }, [_vm._v("Images")])
      ]),
      _vm._v(" "),
      _c(
        "md-tabs",
        { staticClass: "md-transparent" },
        [
          _c(
            "md-tab",
            { attrs: { id: "tab1", "md-label": "Upload and Crop" } },
            [
              _c("CropperImage", {
                attrs: { aspect: _vm.aspectRatio },
                on: {
                  uploadCustomThumbnail: _vm.uploadThumbnail,
                  uploadHero: _vm.uploadHero,
                  upload2x3: _vm.upload2x3
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "md-tab",
            { attrs: { id: "tab2", "md-label": "Upload from gallery" } },
            [
              _c("Loader", { attrs: { loading: _vm.loading, size: 45 } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container-images" },
                _vm._l(_vm.getImagesCropped, function(image) {
                  return _c("div", [
                    _c("img", {
                      staticClass: "img-folder",
                      attrs: { src: _vm.baseUrl + image, alt: "" },
                      on: {
                        click: function($event) {
                          return _vm.selectImage(image)
                        }
                      }
                    })
                  ])
                }),
                0
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a2929d80", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2929d80","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/upload/PopUpImages.vue
// module id = 807
// module chunks = 0